<template>
  <div class="copyFooter" :style="'color:' + color">
    <!-- © 2021 {{VUE_APP_NAME=='WEIIT'?'深圳市微邦互联科技有限公司':'深圳市缔科斯科技有限公司'}} 版权所有 ICP证： <a href="https://beian.miit.gov.cn/" target="_blank" :style="'color:'+color">粤ICP备2021058859号</a> -->
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {}
  },
  created() {},
  computed: {
    VUE_APP_NAME() {
      return process.env.VUE_APP_NAME
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped="scoped">
.copyFooter {
  position: fixed;
  width: 100%;
  line-height: 32px;
  z-index: 4;
  text-align: center;
  bottom: 10px;
  color: #999999;
  font-weight: 300;
  a {
    color: #999999;
    cursor: pointer;
    text-decoration: revert;
  }
}
</style>
